import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptBar } from "@Local/Dashboard/dashboard.util";
/********* 新會員年齡分佈 *********/
const MemberAgeDistribution = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["18-25", "26-35", "36-45", "46-55", "56+"],
			data: [4, 10, 8, 6, 2],
		},
	} = props;
	const { data = [], axisLabels = [] } = adaptBar(sourceData);
	const avgAge = 34;
	const isLoading = data.length === 0;
	const title = "新會員年齡分佈";
	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		graphic: [
			{
				type: "text",
				right: 24,
				top: 22,
				style: {
					text: "中位數",
					fill: "#94A3B8",
					fontSize: 14,
				},
			},
			{
				type: "text",
				right: 24,
				top: 46,
				style: {
					text: `${avgAge}歲`,
					fill: "#5B0F74",
					fontSize: 28,
					fontWeight: 700,
				},
			},
		],
		grid: {
			left: 60,
			right: 40,
			top: 100,
			bottom: 50,
		},
		tooltip: {
			trigger: "axis",
			formatter: params => {
				const item = params[0];
				return `${item.name}<br/>${item.marker} ${item.value} 人`;
			},
			axisPointer: {
				type: "shadow",
			},
		},
		xAxis: {
			type: "category",
			data: axisLabels,
			axisTick: { show: false },
			axisLine: {
				lineStyle: {
					color: "#374151",
				},
			},
			axisLabel: {
				fontSize: 14,
			},
		},
		yAxis: {
			type: "value",
			axisLine: { show: false },
			axisTick: { show: false },
			axisLabel: {
				fontSize: 14,
			},
			splitLine: {
				lineStyle: {
					type: "dashed",
					color: "#E5E7EB",
				},
			},
		},
		series: [
			{
				type: "bar",
				data: data,
				barWidth: 30,
				itemStyle: {
					color: "#5B0F74",
					borderRadius: [6, 6, 0, 0],
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default MemberAgeDistribution;
